import {
  renderBulletButton,
  syncBulletCurrent,
} from "../helpers/paginationBullets";

class ZoomGallery extends HTMLElement {
  constructor() {
    super();
    this.activeVideos = [];

    this.zoomInBtn = this.querySelector("[data-zoom-in]");
    this.zoomOutBtn = this.querySelector("[data-zoom-out]");
    this.maxZoom = 2;

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  _initCarousel() {
    const updateCurrentSlide = () => {
      if (!this.gallerySwiper) return;

      const activeSlide =
        this.gallerySwiper.slides[this.gallerySwiper.realIndex];

      this.gallerySwiper.slides.forEach((slide) => {
        if (slide == activeSlide) {
          activeSlide.removeAttribute("aria-hidden");
          activeSlide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = null;
          });
        } else {
          slide.setAttribute("aria-hidden", "true");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = -1;
          });
        }
      });
    };

    const swiperParams = {
      modules: [
        this.swiperLib.Keyboard,
        this.swiperLib.Navigation,
        this.swiperLib.Pagination,
        this.swiperLib.Zoom,
      ],
      slidesPerView: "auto",
      initialSlide: this.dataset.preselectMediaIndex,
      speed: 400,
      watchSlidesProgress: true,
      zoom: {
        maxRatio: this.maxZoom,
        minRatio: 1,
      },
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        renderBullet: renderBulletButton,
      },
      init: false,
      on: {
        realIndexChange: () => updateCurrentSlide(),
        paginationUpdate: syncBulletCurrent,
      },
    };

    this.gallerySwiper = new this.swiperLib.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    updateCurrentSlide();

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.nextZoomRatio = this.gallerySwiper.zoom.scale + 1;

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    this.gallerySwiper.on("zoomChange", () => {
      setTimeout(() => {
        if (this.zoomInBtn) {
          this.zoomInBtn.classList.toggle(
            "grey-out",
            this.gallerySwiper.zoom.scale >= this.maxZoom,
          );
        }

        if (this.zoomOutBtn) {
          this.zoomOutBtn.classList.toggle(
            "grey-out",
            this.gallerySwiper.zoom.scale <= 1,
          );
        }
      }, 100);
    });

    // Default toggles on double click so manually toggle on click
    this.gallerySwiper.on("click", () => {
      if (this.gallerySwiper.zoom.scale < this.maxZoom) {
        this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
      } else {
        this.gallerySwiper.zoom.out();
      }
    });

    this.zoomInBtn?.addEventListener("click", () => {
      if (this.gallerySwiper.zoom.scale > this.maxZoom) return;
      this.gallerySwiper.zoom.in(this.gallerySwiper.zoom.scale + 1);
    });

    this.zoomOutBtn?.addEventListener("click", () => {
      this.gallerySwiper.zoom.out();
    });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("zoom-gallery")) {
  customElements.define("zoom-gallery", ZoomGallery);
}
